export const ADVERTS_PACKAGE = 'adverts_package';
export const SEARCH_RESULTS_PACKAGE = 'search_results_package';
export const RECOMMENDED_PACKAGES_PACKAGE = 'recommended_packages_package';
export const POPULAR_HOTELS_PACKAGE = 'popular_hotels_package';
export const SAVED_PACKAGES_PACKAGE = 'saved_packages_package';
